import { atom } from 'jotai'

export const modalAtom = atom(false)
export const modalPickupAtom = atom(false)
export const modalDeliveryAddressAtom = atom(false)
export const catchFocusAtom = atom(true)
